<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :buttonsVisibility="buttonsVisibility"
                :initialSort="initialSort"
                :showModeOpenId="showModeOpenId"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <ProjectStatementForm :formProps="formProps">
                </ProjectStatementForm>
            </template>
            <template #search="searchProps">
                <ProjectStatementSearch :searchProps="searchProps">
                </ProjectStatementSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref } from "vue";
import ProjectStatementForm from './ProjectStatementForm.vue'
import ProjectStatementSearch from './ProjectStatementSearch.vue'
import { __, getFromUrl } from '@pages/Helper/utils.js';

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
